export const BASE_URL=process.env.REACT_APP_PROD_BASE_URL
